/* AIOS Serum GWP Video Loop — Alice 08/07/26 (V4 draft).
   Guarantees the free-serum cart thumbnail video (video.aios-serum-vid) plays and
   LOOPS on every device — including iOS Safari, where the bare `loop` attribute is
   unreliable and playback dies when the cart drawer re-renders its innerHTML.

   Speed-safe: the video keeps preload="none"; we only call .play() once the element
   is actually on screen (IntersectionObserver), so no bytes load until the cart opens.

   `subscribe`, `PUB_SUB_EVENTS` are bare theme globals (assets/constants.js), guarded
   with typeof. Marker: AIOS-SERUM-VID-LOOP. */
(function () {
  function arm(v) {
    if (v.__aiosSerumLoop) return;
    v.__aiosSerumLoop = true;
    // Force the attributes iOS needs to autoplay + loop, in case markup is stripped.
    v.muted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('loop', '');
    // Belt-and-braces loop: if the native loop ever drops, restart manually.
    v.addEventListener('ended', function () {
      try { v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
    });
    var tryPlay = function () { try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} };
    // Also nudge it back to playing if the browser pauses it (tab blur, low-power exit, etc.).
    v.addEventListener('pause', function () {
      if (!v.__aiosStopped && v.offsetParent !== null) setTimeout(tryPlay, 60);
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) tryPlay(); });
      }, { threshold: 0.1 });
      io.observe(v);
    } else {
      tryPlay();
    }
  }

  function scan(root) {
    var vids = (root || document).querySelectorAll('video.aios-serum-vid');
    for (var i = 0; i < vids.length; i++) arm(vids[i]);
  }

  function wire() {
    scan(document);
    // Re-arm whenever the cart re-renders (our auto-add / qty changes swap #CartDrawer innerHTML,
    // which destroys the old <video> and inserts a fresh one that needs arming again).
    var cd = document.querySelector('#CartDrawer');
    if (cd && 'MutationObserver' in window) {
      new MutationObserver(function () { scan(cd); }).observe(cd, { childList: true, subtree: true });
    }
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(function () { scan(document); }, 50); });
      }
    } catch (e) {}
  }

  if (document.readyState !== 'loading') wire();
  else document.addEventListener('DOMContentLoaded', wire);
})();
